export const css = {
    root: 'nRQkpblv',
    ' _key': 'apic-theme/apic/micro/backview/backview'
};
export default css;
